import * as React from 'react';

import styles from './ClipboardModify.css';
import { clipboardModifyHandler } from './helpers';

export class ClipboardModify extends React.PureComponent<React.PropsWithChildren> {
  private root: React.RefObject<HTMLDivElement> = React.createRef();
  public componentDidMount() {
    if (this.root.current) {
      this.root.current.addEventListener('copy', clipboardModifyHandler);
    }
  }
  public componentWillUnmount() {
    if (this.root.current) {
      this.root.current.removeEventListener('copy', clipboardModifyHandler);
    }
  }
  public render() {
    return (
      <div ref={this.root} className={styles['container']}>
        {this.props.children}
      </div>
    );
  }
}
